<div class="body">
  <div class="container h-screen w-screen flex align-items-center justify-content-center text-center">

    <div class="right-column">
      <div>
        <img src="logo.png" alt="Logo" class="logo" width="128">
        <h2>USER LOGIN</h2>

        <!--                    <div class="flex flex-row mb-6">-->
        <!--                        <app-language-selector style="margin: auto" [colorized]="false"></app-language-selector>-->
        <!--                    </div>-->

        <form #form='ngForm' class="login-form mb-3 fluid flex-column text-center" (ngSubmit)="login()">
          <div class="field">
            <div class="circle">
              <i class="fa fa-user"></i>
            </div>
            <input pInputText name="username" type="text"
                   [placeholder]="translations.auth.email | translate" required
                   class="inputfield w-full"
                   [(ngModel)]="username">
          </div>
          <div class="field">
            <div class="circle circle-right">
              <i class="fa fa-lock"></i>
            </div>
            <input pInputText name="password" type="password"
                   [placeholder]="translations.auth.password | translate"
                   required
                   class="inputfield w-full"
                   [(ngModel)]="password">
          </div>
          <div class="field">
            <button pRipple pButton type="submit" class="" [disabled]="formSubmitting"
                    [label]="(!formSubmitting
                  ? translations.auth.login
                  : translations.auth.loading) | translate"
            ></button>
          </div>
          <a pButton pRipple class="p-button-text" [href]="Routing.recoveryPassword.getBasePath()">
            {{ translations.auth.passwordLost | translate }}
          </a>
        </form>

        <div
          class="surface-card py-4 px-5 sm:px-7 shadow-2 w-11 sm:w-30rem mt-4 mx-auto justify-content-center flex"
          *ngIf="allowRegistration"
          style="border-radius:14px">
          <a pButton pRipple [href]="RoutingConstants.register">
            {{ translations.auth.registerQuestion | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog [visible]="insertingTwoFactor" appendTo="body" [modal]="true"
          [header]="translations.auth.twoFactorTitle | translate"
          [closable]="false">
  <div class="flex flex-column">
    <p>{{ translations.auth.twoFactorDescription | translate }}</p>
    <div class="flex flex-column">
      <input pInputText name="twoFactorCode" type="text"
             [placeholder]="translations.auth.twoFactorCode | translate" required
             class="inputfield w-full"
             [(ngModel)]="twoFactorCode">
      <br>
      <button pRipple pButton type="submit" class="" [disabled]="formSubmitting"
              (click)="authenticateTwoFactor()"
              [label]="(!formSubmitting
                  ? translations.auth.login
                  : translations.auth.loading) | translate"
      ></button>
    </div>
  </div>
</p-dialog>
